import { DOCUMENT } from '@angular/common';
import {EventEmitter, Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  _loadingSubscriber: EventEmitter<string> = new EventEmitter<string>();
  loadingCounter = 0;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  toggleLoading(value: 'SHOW' | 'HIDE'): void {
    this._loadingSubscriber.emit(value)
  }

  hideLoading(): void {
    this.loadingCounter--;
    if(this.loadingCounter <= 0) {
      this.document.body.style.overflow = 'auto';
    }
    this._loadingSubscriber.emit('HIDE')
  }

  showLoading(): void {
    this.loadingCounter++;
    this.document.body.style.overflow = 'hidden';
    this._loadingSubscriber.emit('SHOW')
  }
}
